import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'division'
})
export class DivisionPipe implements PipeTransform {
    /**
     *
     * @param value
     * @param d
     * @returns {number}
     */
    transform(value: number, d: number): number {
        return (value / d);
    }
}


// WEBPACK FOOTER //
// ./src/pipes/division.pipe.ts